import { render, staticRenderFns } from "./AiCarDrawer.vue?vue&type=template&id=285d1cf8&scoped=true&"
import script from "./AiCarDrawer.vue?vue&type=script&lang=js&"
export * from "./AiCarDrawer.vue?vue&type=script&lang=js&"
import style0 from "./AiCarDrawer.vue?vue&type=style&index=0&id=285d1cf8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "285d1cf8",
  null
  
)

export default component.exports